//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      enabled: false
    };
  },
  methods: {
    $ready: function $ready() {
      this.enabled = this.spec.enabled;
    },
    changed: function changed() {
      if (this.enabled) {
        GLib.action.execute(this.spec.onEnabled, this);
      } else {
        GLib.action.execute(this.spec.onDisabled, this);
      }
    }
  }
};